var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlug(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.975 0.898438H8.025C6.35434 0.898438 5 2.25278 5 3.92344V17.8734C5 19.5441 6.35434 20.8984 8.025 20.8984H21.975C23.6457 20.8984 25 19.5441 25 17.8734V3.92344C25 2.25278 23.6457 0.898438 21.975 0.898438Z",
    fill: "#DCDCE4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2625 4.02344H9.7375C8.84694 4.02344 8.125 4.74538 8.125 5.63594V16.1609C8.125 17.0515 8.84694 17.7734 9.7375 17.7734H20.2625C21.1531 17.7734 21.875 17.0515 21.875 16.1609V5.63594C21.875 4.74538 21.1531 4.02344 20.2625 4.02344Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6883 8.51172H12.0508V11.7742H13.6883V8.51172Z",
    fill: "#AAAAB1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9627 8.51172H16.3252V11.7742H17.9627V8.51172Z",
    fill: "#AAAAB1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3258 13.9109C16.3258 13.5595 16.1862 13.2225 15.9377 12.974C15.6892 12.7255 15.3522 12.5859 15.0008 12.5859C14.6494 12.5859 14.3124 12.7255 14.0639 12.974C13.8154 13.2225 13.6758 13.5595 13.6758 13.9109H16.3258Z",
    fill: "#AAAAB1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1504 22.7102V26.1227C14.1504 26.5002 14.076 26.8741 13.9315 27.2229C13.7871 27.5717 13.5753 27.8886 13.3083 28.1556C13.0414 28.4226 12.7244 28.6343 12.3756 28.7788C12.0268 28.9233 11.6529 28.9977 11.2754 28.9977H5.50039V19.8477H11.2879C12.0461 19.8509 12.7722 20.1536 13.3083 20.6897C13.8445 21.2258 14.1471 21.952 14.1504 22.7102Z",
    fill: "#AAAAB1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 23.1375V20.9375H1.0875V23.1375H5.5Z",
    fill: "#DCDCE4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5127 27.4617V25.2617H1.10019V27.4617H5.5127Z",
    fill: "#DCDCE4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2627 26.0977V22.7227H12.8877V26.0977H16.2627Z",
    fill: "#AAAAB1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9004 25.2617V23.5742H16.2004V25.2617H28.9004Z",
    fill: "#AAAAB1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlug);
export default __webpack_public_path__ + "static/media/plug.4f7c82fe5751ee84d2edf30e4a690fbd.svg";
export { ForwardRef as ReactComponent };